module.exports = __webpack_public_path__ + "img/redEdit.9c9f8dec.svg";